import React, {
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle,
    useRef,
    Fragment
} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Select from "react-select";
import _ from "lodash";
import moment from "moment";
import uuid from "uuid";

import Dropzone from "../global/form/Dropzone";
import MaterialDateTimePicker from "../global/form/MaterialDateTimePicker";
import OverLoading from "../global/OverLoading";
import { getCategories } from "../../actions/admin/category";
import { getMalls } from "../../actions/admin/mall";
import { getStores } from "../../actions/admin/store";
import { updatePromo, getPromo } from "../../actions/admin/promo";
import { toggleModal } from "../../actions/modal";
import { getOfferOptions } from "../../actions/admin/offer_option";

const FormEdit = forwardRef(
    (
        {
            id,
            updatePromo,
            getPromo,
            getCategories,
            getMalls,
            getStores,
            toggleModal,
            getOfferOptions
        },
        ref
    ) => {
        const submitButtonRef = useRef();

        const selectCategoryRef = useRef();

        const selectStoreRef = useRef();

        const selectMallRef = useRef();

        const titleRef = useRef();

        useImperativeHandle(ref, () => ({
            submitForm() {
                submitButtonRef.current.click();
            }
        }));

        const [loading, setLoading] = useState(false);

        const [categoryOptions, setCategoryOptions] = useState([]);

        const [mallOptions, setMallOptions] = useState([]);

        const [storeOptions, setStoreOptions] = useState([]);

        const [selectedCategoryOptions, setSelectedCategoryOptions] = useState(
            []
        );

        const [selectedMallOption, setSelectedMallOption] = useState(null);


        const [selectedStoreOption, setSelectedStoreOption] = useState(null);
        const [arrayOfferOptions, setArrayOfferOptions] = useState([]);
        const [objectOfferOptions, setObjectOfferOptions] = useState([]);
        const [selectedOfferOption, setSelectedOfferOption] = useState(null);
        const [inputValues, setInputValues] = useState(null);

        const [formData, setFormData] = useState({
            title: "",
            description: "",
            isDeal: "true",
            isEvent: "false",
            source: "",
            isStorePromo: "true",
            isMallPromo: "false",
            images: [],
            files: [],
            dateFrom: new Date(moment().startOf("day")),
            dateTill: new Date(moment().startOf("day")),
            categoryIds: [],
            offerOptionId: "",
        });

        const {
            title,
            description,
            isDeal,
            isEvent,
            source,
            isStorePromo,
            isMallPromo,
            images,
            dateFrom,
            dateTill,
            categoryIds,
            offerOptionId
        } = formData;

        useEffect(() => {
            const fetchPromoData = async () => {
                const promo = await getPromo(id);
                setFormData({
                    title: promo.title,
                    description: promo.description,
                    source: promo.source,
                    images: promo.images,
                    categoryIds: _.map(promo.categories, "id"),
                    isDeal: promo.isDeal ? "true" : "false",
                    isEvent: promo.isEvent ? "true" : "false",
                    isMallPromo: promo.isMallPromo ? "true" : "false",
                    isStorePromo: promo.isStorePromo ? "true" : "false",
                    dateFrom: new Date(promo.dateFrom),
                    dateTill: new Date(promo.dateTill),
                    offerOptionId: promo.offerOptionUsed
                });

            };



            fetchPromoData();
        }, [id, getPromo]);

        useEffect(() => {
            let selectedOptions = [];
            const fetchCategoriesData = async () => {
                const categories = await getCategories();
                const categoryOptions = categories.map(category => {
                    if (categoryIds.includes(category.id)) {
                        selectedOptions.push({
                            value: category.id,
                            label: category.name
                        });
                    }

                    return {
                        value: category.id,
                        label: category.name
                    };
                });
                setCategoryOptions(categoryOptions);
            };

            fetchCategoriesData();
            setSelectedCategoryOptions(selectedOptions);
        }, [getCategories, categoryIds]);

        useEffect(() => {
            const fetchMallsData = async () => {
                const malls = await getMalls();
                if (isMallPromo === "true") {
                    const selectedMall = _.find(malls, ["name", source]);
                    if (selectedMall) {
                        setSelectedMallOption({
                            value: selectedMall.id,
                            label: selectedMall.name
                        });
                    }
                }
                const mallOptions = malls.map(mall => {
                    return {
                        value: mall.id,
                        label: mall.name
                    };
                });
                setMallOptions(mallOptions);
            };

            fetchMallsData();
        }, [getMalls, isMallPromo, source]);

        useEffect(() => {
            const fetchStoresData = async () => {
                const stores = await getStores();
                if (isStorePromo === "true") {
                    const selectedStore = _.find(stores, ["name", source]);
                    if (selectedStore) {
                        setSelectedStoreOption({
                            value: selectedStore.id,
                            label: selectedStore.name
                        });
                    }
                }
                const storeOptions = stores.map(store => {
                    return {
                        value: store.id,
                        label: store.name
                    };
                });
                setStoreOptions(storeOptions);
            };

            fetchStoresData();
        }, [getStores, isStorePromo, source]);

        useEffect(() => {
            const fetchOfferOptions = async () => {
                const offerOptions = await getOfferOptions();
                setArrayOfferOptions(offerOptions);
                const convertOfferOptions = _.groupBy(offerOptions, function (
                    option
                ) {
                    return option.group;
                });
                setObjectOfferOptions(convertOfferOptions);
                if (offerOptionId) {
                    var event = { target: { name: 'offerOptionId', value: offerOptionId } };
                    handleOfferOption(event);
                }
            };

            fetchOfferOptions();
        }, [getOfferOptions]);



        const onChange = e => {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        };

        const handleOfferOption = e => {
            setFormData({ ...formData, [e.target.name]: e.target.value });
            if (e.target.name === "offerOptionId") {
                if (e.target.value !== "") {
                    const selectedOfferOption = _.find(arrayOfferOptions, [
                        "id",
                        parseInt(e.target.value)
                    ]);
                    setSelectedOfferOption(selectedOfferOption);
                    let inputValues = [];
                    selectedOfferOption.content.forEach((item, index) => {
                        if (item.isInput === true) {
                            inputValues["titleInput" + index] = "";
                        }
                    });
                    setInputValues(inputValues);
                } else {
                    setSelectedOfferOption(null);
                }
            }
        };

        const renderOfferOptions = Object.keys(objectOfferOptions).map(key => {
            return (
                <Fragment key={uuid.v4()}>
                    <option value={key} key={uuid.v4()} disabled>
                        {key}
                    </option>
                    {objectOfferOptions[key].map(option => {
                        let content = "";
                        option.content.forEach(item => {
                            if (item.text !== "") {
                                content += item.text;
                            } else {
                                content += "___";
                            }
                        });
                        return (
                            <option value={option.id} key={uuid.v4()}>
                                {content}
                            </option>
                        );
                    })}
                </Fragment>
            );
        });


        const handleChangeCategoryOptions = selectedOptions => {
            setSelectedCategoryOptions(selectedOptions);
            setFormData({
                ...formData,
                categoryIds: _.map(selectedOptions, "value")
            });
        };

        const handleChangeMallOption = selectedOption => {
            setSelectedMallOption(selectedOption);
            setFormData({
                ...formData,
                source: selectedOption.label
            });
        };

        const handleChangeStoreOption = selectedOption => {
            setSelectedStoreOption(selectedOption);
            setFormData({
                ...formData,
                source: selectedOption.label
            });
        };

        const onSubmit = async e => {
            e.preventDefault();
            setLoading(true);
            setFormData({
                ...formData,
                title: titleRef.current.innerText
            });
            formData['title'] = titleRef.current.innerText;
            const updatePromoResponse = await updatePromo(formData, id);
            setLoading(false);
            if (updatePromoResponse) toggleModal();
        };

        const getSelectedCategoryOptionsValue = () => {
            if (selectedCategoryOptions && selectedCategoryOptions.length)
                return selectedCategoryOptions.length;
            else return "";
        };

        const getSelectedStoreOptionValue = () => {
            if (selectedStoreOption) return selectedStoreOption.value;
            else return "";
        };

        const getSelectedMallOptionValue = () => {
            if (selectedMallOption) return selectedMallOption.value;
            else return "";
        };

        const renderInput =
            selectedOfferOption !== null ? (
                selectedOfferOption.content.map((item, index) => {
                    if (item.isHint === false) {
                        if (item.isInput === false) {
                            return (
                                <Fragment key={index}>
                                    {" " + item.text + " "}
                                </Fragment>
                            );
                        } else {
                            return (
                                <Fragment key={index}>
                                    <input
                                        type="text"
                                        value={
                                            inputValues["titleInput" + index]
                                        }
                                        name={"titleInput" + index}
                                        onChange={e => onChangeTitleInput(e)}
                                        required
                                        style={{ width: "80px" }}
                                    />
                                </Fragment>
                            );
                        }
                    }

                    return <Fragment key={index}></Fragment>;
                })
            ) : (
                    <Fragment></Fragment>
                );

        const renderTitle =
            selectedOfferOption !== null ? (
                selectedOfferOption.content.map((item, index) => {
                    if (item.isHint === false) {
                        if (item.isInput === false) {
                            return <Fragment key={index}>{item.text}</Fragment>;
                        } else {
                            return (
                                <Fragment key={index}>
                                    {inputValues["titleInput" + index]}
                                </Fragment>
                            );
                        }
                    }

                    return <Fragment key={index}></Fragment>;
                })
            ) : (
                    <Fragment>{title}</Fragment>
                );

        const onChangeTitleInput = e => {
            setInputValues({
                ...inputValues,
                [e.target.name]: e.target.value
            });
        };

        return (
            <form
                className="form position-relative"
                onSubmit={e => onSubmit(e)}
                autoComplete="off"
            >
                {loading && <OverLoading />}
                <div className="form-group">
                    <label className="col-form-label">Category *</label>
                    <Select
                        value={selectedCategoryOptions}
                        onChange={handleChangeCategoryOptions}
                        options={categoryOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        blurInputOnSelect={false}
                        ref={selectCategoryRef}
                    />
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{
                            opacity: 0,
                            width: "100%",
                            height: 0,
                            position: "absolute"
                        }}
                        value={getSelectedCategoryOptionsValue()}
                        onChange={e => {
                            e.preventDefault();
                        }}
                        onFocus={() => selectCategoryRef.current.focus()}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="col-form-label">Title *</label>
                    {/* <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={title}
                        onChange={e => onChange(e)}
                        required
                    /> */}
                    <div className="form-group mb-4">
                        <div className="input-group mb-2">
                            <div className="input-group-prepend">
                                <div className="input-group-text">Options</div>
                            </div>
                            <select
                                className="form-control"
                                name="offerOptionId"
                                value={offerOptionId}
                                onChange={e => handleOfferOption(e)}
                                required
                            >
                                ref={renderOfferOptions}
                                {/* <option value="">Select a option</option>
                                {renderOfferOptions} */}
                            </select>
                        </div>
                    </div>
                    <div className="form-group mb-4">Input: {renderInput}</div>
                    <div className="form-group mb-4">
                        Title:{" "}
                        <span className="text-primary" ref={titleRef}>
                            {renderTitle}
                        </span>
                    </div>
                </div>
                <div className="form-group">
                    <label className="col-form-label">Description</label>
                    <textarea
                        className="form-control"
                        name="description"
                        value={description}
                        onChange={e => onChange(e)}
                    >
                        {description}
                    </textarea>
                </div>
                <div className="form-group">
                    <div className="form-check form-check-inline padding-bottom-15">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isDeal"
                                value="true"
                                checked={isDeal === "true"}
                                onChange={() => {
                                    setFormData({
                                        ...formData,
                                        isDeal:
                                            isDeal === "true"
                                                ? "false"
                                                : "true",
                                        isEvent:
                                            isEvent === "true"
                                                ? "false"
                                                : "true"
                                    });
                                }}
                            />{" "}
                            Is Deal
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isEvent"
                                value="false"
                                checked={isEvent === "true"}
                                onChange={() => {
                                    setFormData({
                                        ...formData,
                                        isDeal:
                                            isDeal === "true"
                                                ? "false"
                                                : "true",
                                        isEvent:
                                            isEvent === "true"
                                                ? "false"
                                                : "true"
                                    });
                                }}
                            />{" "}
                            Is Event
                        </label>
                    </div>
                </div>
                <div className="form-group">
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isStorePromo"
                                value="true"
                                checked={isStorePromo === "true"}
                                onChange={() => {
                                    setFormData({
                                        ...formData,
                                        isStorePromo:
                                            isStorePromo === "true"
                                                ? "false"
                                                : "true",
                                        isMallPromo:
                                            isMallPromo === "true"
                                                ? "false"
                                                : "true"
                                    });
                                }}
                            />{" "}
                            Is Store Promo
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isMallPromo"
                                value="false"
                                checked={isMallPromo === "true"}
                                onChange={() => {
                                    setFormData({
                                        ...formData,
                                        isStorePromo:
                                            isStorePromo === "true"
                                                ? "false"
                                                : "true",
                                        isMallPromo:
                                            isMallPromo === "true"
                                                ? "false"
                                                : "true"
                                    });
                                }}
                            />{" "}
                            Is Mall Promo
                        </label>
                    </div>
                </div>
                {isStorePromo === "true" && isMallPromo === "false" ? (
                    <div className="form-group">
                        <label className="col-form-label">Store *</label>
                        <Select
                            value={selectedStoreOption}
                            onChange={handleChangeStoreOption}
                            options={storeOptions}
                            placeholder={"Select a store"}
                            ref={selectStoreRef}
                        />
                        <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{
                                opacity: 0,
                                width: "100%",
                                height: 0,
                                position: "absolute"
                            }}
                            value={getSelectedStoreOptionValue()}
                            onChange={e => {
                                e.preventDefault();
                            }}
                            onFocus={() => selectStoreRef.current.focus()}
                            required
                        />
                    </div>
                ) : (
                        ""
                    )}

                {isMallPromo === "true" && isStorePromo === "false" ? (
                    <div className="form-group">
                        <label className="col-form-label">Mall *</label>
                        <Select
                            value={selectedMallOption}
                            onChange={handleChangeMallOption}
                            options={mallOptions}
                            placeholder={"Select a mall"}
                            ref={selectMallRef}
                        />
                        <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{
                                opacity: 0,
                                width: "100%",
                                height: 0,
                                position: "absolute"
                            }}
                            value={getSelectedMallOptionValue()}
                            onChange={e => {
                                e.preventDefault();
                            }}
                            onFocus={() => selectMallRef.current.focus()}
                            required
                        />
                    </div>
                ) : (
                        ""
                    )}
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label className="col-form-label">Date From*</label>
                            <div>
                                <MaterialDateTimePicker
                                    value={dateFrom}
                                    onChange={dateFrom =>
                                        setFormData({ ...formData, dateFrom })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label className="col-form-label">Date Till*</label>
                            <div>
                                <MaterialDateTimePicker
                                    value={dateTill}
                                    onChange={dateTill =>
                                        setFormData({ ...formData, dateTill })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label className="col-form-label">Images *</label>
                    <Dropzone
                        multiple={true}
                        placeholder="Choose the images"
                        onDrop={files => {
                            setFormData({
                                ...formData,
                                files: files
                            });
                        }}
                        onRemoveSource={source => {
                            setFormData({
                                ...formData,
                                images: images.filter(image => {
                                    return image !== source;
                                })
                            });
                        }}
                        defaultSources={images}
                    />
                </div>
                <div className="form-group">
                    <input
                        type="submit"
                        className="btn btn-primary mr-1 d-none"
                        value="Save"
                        ref={submitButtonRef}
                    />
                </div>
            </form>
        );
    }
);

FormEdit.propTypes = {
    id: PropTypes.number.isRequired,
    updatePromo: PropTypes.func.isRequired,
    getPromo: PropTypes.func.isRequired,
    getCategories: PropTypes.func.isRequired,
    getMalls: PropTypes.func.isRequired,
    getStores: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    getOfferOptions: PropTypes.func.isRequired
};

export default connect(
    null,
    {
        updatePromo,
        getPromo,
        getCategories,
        getMalls,
        getStores,
        toggleModal,
        getOfferOptions
    },
    null,
    {
        forwardRef: true
    }
)(FormEdit);
